import { render, staticRenderFns } from "./chatBtn.vue?vue&type=template&id=061f70a3&scoped=true"
import script from "./chatBtn.vue?vue&type=script&lang=js"
export * from "./chatBtn.vue?vue&type=script&lang=js"
import style0 from "./chatBtn.vue?vue&type=style&index=0&id=061f70a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f70a3",
  null
  
)

export default component.exports